import { useSeo } from "../components/site/Seo";
import { SectionLabel } from "../components/site/Reveal";
import { useContent } from "../lib/content";

const H = ({ children }) => <h2 className="mt-12 mb-3 font-display-n font-bold text-white text-xl">{children}</h2>;

export default function Privacy() {
  const c = useContent().company;
  useSeo("Privacy e cookie policy");
  return (
    <main data-testid="privacy-page" className="pt-32 sm:pt-40 pb-24">
      <article className="mx-auto max-w-3xl px-5 sm:px-8 text-slate-300 leading-relaxed text-[15px]">
        <SectionLabel>Documentazione legale</SectionLabel>
        <h1 className="mt-6 font-display font-extrabold text-white text-4xl sm:text-5xl">Privacy e cookie policy</h1>
        <p className="mt-6 text-sm text-slate-400">Testo base ai sensi del Regolamento UE 2016/679 (GDPR). Da verificare e completare con il proprio consulente legale prima della pubblicazione.</p>

        <H>1. Titolare del trattamento</H>
        <p>{c.legal_name} ({c.name}), {c.address}, P.IVA {c.vat}. Email: <a className="underline" href={`mailto:${c.email}`}>{c.email}</a> · Tel. {c.phone}.</p>

        <H>2. Dati trattati</H>
        <p>Tramite il modulo di richiesta consulenza raccogliamo: nome e cognome, azienda, telefono, email, settore di attività e area geografica. Raccogliamo inoltre dati tecnici di navigazione (es. indirizzo IP) necessari al funzionamento e alla sicurezza del sito.</p>

        <H>3. Finalità e base giuridica</H>
        <p>I dati del modulo sono trattati per ricontattarti e fornirti le informazioni richieste sul programma TERMONLINE (misure precontrattuali su tua richiesta, art. 6.1.b GDPR). I dati di analisi e marketing sono trattati solo previo consenso (art. 6.1.a GDPR).</p>

        <H>4. Conservazione</H>
        <p>Le richieste sono conservate per il tempo necessario a gestire il contatto commerciale e comunque non oltre [periodo di conservazione], salvo obblighi di legge.</p>

        <H>5. Destinatari</H>
        <p>I dati possono essere trattati da fornitori tecnici che operano come responsabili del trattamento (hosting, invio email, strumenti di analisi). Non vengono diffusi.</p>

        <H>6. Diritti dell'interessato</H>
        <p>Puoi esercitare in qualsiasi momento i diritti di accesso, rettifica, cancellazione, limitazione, portabilità e opposizione scrivendo a {c.email}. Hai diritto di proporre reclamo al Garante per la protezione dei dati personali.</p>

        <H>7. Cookie</H>
        <p><strong className="text-white">Necessari:</strong> indispensabili al funzionamento del sito e alla memorizzazione delle tue scelte sui cookie. Non richiedono consenso.</p>
        <p className="mt-2"><strong className="text-white">Analisi:</strong> Google Analytics 4, attivato solo dopo il consenso, per misurare in forma aggregata le visite.</p>
        <p className="mt-2"><strong className="text-white">Marketing e conversioni:</strong> Meta Pixel (Facebook e Instagram), Google Tag Manager e strumenti pubblicitari collegati, attivati solo dopo il consenso, per misurare le richieste inviate dal sito e l'efficacia delle campagne.</p>
        <p className="mt-4">Puoi modificare le tue scelte in qualsiasi momento.</p>
        <button data-testid="privacy-cookie-prefs" onClick={() => window.dispatchEvent(new Event("open-cookie-prefs"))}
          className="mt-4 h-11 px-5 rounded-full border border-white/15 text-white text-sm hover:bg-white/5">Gestisci preferenze cookie</button>
      </article>
    </main>
  );
}
